export default {"width":448,"height":100};